import{d as t}from"./chunk-JJLYL3SL.js";import{b as s,c as r}from"./chunk-YP6BA2ZK.js";import{m as o}from"./chunk-HBP5N4FR.js";o();var i=()=>{let e=t(s),c=t(r);return{customToasts:e,transactionToasts:c}};export{i as a};
//# sourceMappingURL=chunk-J75OE46C.js.map
